import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#0F172A] text-gray-300">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-white text-lg font-bold mb-4">
              Schössow Dienstleistungen
            </h3>
            <p className="text-sm mb-4">Schnell. Diskret. Festpreis.</p>
            <div className="space-y-3">
              <div className="flex items-start gap-2">
                <MapPin className="h-5 w-5 text-[#16A34A] flex-shrink-0 mt-0.5" />
                <div className="text-sm">
                  Neben dem Brand 10<br />
                  44135 Dortmund<br />
                  Nordrhein-Westfalen
                </div>
              </div>
              <div className="flex items-center gap-2">
                <Clock className="h-5 w-5 text-[#16A34A] flex-shrink-0" />
                <span className="text-sm">Mo–Sa 08:00–20:00</span>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold mb-4">Leistungen</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/haushaltsaufloesung-dortmund" className="hover:text-[#16A34A] transition-colors">
                  Haushaltsauflösung
                </Link>
              </li>
              <li>
                <Link to="/wohnungsaufloesung-dortmund" className="hover:text-[#16A34A] transition-colors">
                  Wohnungsauflösung
                </Link>
              </li>
              <li>
                <Link to="/messie-wohnung-dortmund" className="hover:text-[#16A34A] transition-colors">
                  Messi-Wohnung Räumung
                </Link>
              </li>
              <li>
                <Link to="/keller-dachboden-entruempelung-dortmund" className="hover:text-[#16A34A] transition-colors">
                  Keller & Dachboden
                </Link>
              </li>
              <li>
                <Link to="/sperrmuell-abtransport-dortmund" className="hover:text-[#16A34A] transition-colors">
                  Sperrmüll-Abtransport
                </Link>
              </li>
              <li>
                <Link to="/nachlassaufloesung-dortmund" className="hover:text-[#16A34A] transition-colors">
                  Nachlassauflösung
                </Link>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Schnellzugriff</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/preise" className="hover:text-[#16A34A] transition-colors">
                  Preise & Ablauf
                </Link>
              </li>
              <li>
                <Link to="/einsatzgebiet-dortmund" className="hover:text-[#16A34A] transition-colors">
                  Einsatzgebiet
                </Link>
              </li>
              <li>
                <Link to="/ueber-uns" className="hover:text-[#16A34A] transition-colors">
                  Über uns
                </Link>
              </li>
              <li>
                <Link to="/faq" className="hover:text-[#16A34A] transition-colors">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/blog" className="hover:text-[#16A34A] transition-colors">
                  Ratgeber
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="hover:text-[#16A34A] transition-colors">
                  Kontakt
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-4">Kontakt</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href="tel:+4923139085116"
                  className="flex items-center gap-2 hover:text-[#16A34A] transition-colors"
                >
                  <Phone className="h-4 w-4 text-[#16A34A]" />
                  0231 39085116
                </a>
              </li>
              <li>
                <a
                  href="mailto:info@haushaltsaufloesung.services"
                  className="flex items-center gap-2 hover:text-[#16A34A] transition-colors break-all"
                >
                  <Mail className="h-4 w-4 text-[#16A34A] flex-shrink-0" />
                  info@haushaltsaufloesung.services
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-700 flex flex-col md:flex-row justify-between items-center gap-4 text-sm">
          <p>&copy; 2025 Schössow Dienstleistungen. Alle Rechte vorbehalten.</p>
          <div className="flex gap-6">
            <Link to="/impressum" className="hover:text-[#16A34A] transition-colors">
              Impressum
            </Link>
            <Link to="/datenschutz" className="hover:text-[#16A34A] transition-colors">
              Datenschutz
            </Link>
            <Link to="/sitemap" className="hover:text-[#16A34A] transition-colors">
              Sitemap
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;